(function () {
  /**
   * BatchGeoMarkerMeasureMarker creates a marker for the BatchGeoMarkerMeasure
   * component. The marker under the hood is actually an overlay and it is
   * draggable.
   */
  var BatchGeoMarkerMeasureMarker = function () {
    this.marker = null;
  };

  /**
   * Creates a draggable marker at the given position if it does not exist. If
   * it does exist it will try showing it instead of creating a new instance.
   *
   * @param {object} position An obj with lat/lng props or a LatLng GMaps obj
   * @returns {object} A Google Maps Marker class
   */
  BatchGeoMarkerMeasureMarker.prototype.createMarker = function (position) {
    if (!this.marker) {
      this.marker = new window.BatchGeoMarkerMeasureMarkerOverlay(position);
    } else {
      this.marker.show(position);
    }
  };

  /**
   * Removes the draggable marker from the map and sets the marker to null
   * @return {object} returns a marker in the form of a Google Maps Marker
   */
  BatchGeoMarkerMeasureMarker.prototype.getMarker = function () {
    return this.marker;
  };

  /**
   * Removes the draggable marker from the map by hiding it.
   * @return {undefined}
   */
  BatchGeoMarkerMeasureMarker.prototype.clearMarker = function () {
    if (!this.marker) return;
    this.marker.hide();
  };

  window.BatchGeoMarkerMeasureMarker = BatchGeoMarkerMeasureMarker;
})();
